import { fyaiScreenshots } from "@/mocks/fyai-data";

export default function FyaiScreenshots() {
  return (
    <section id="screenshots" className="w-full bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="mb-12 max-w-2xl">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900">
          <i className="ri-smartphone-line" />
          软件截图
        </span>
        <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
          看看风月AI的每一面
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
          从探索角色到沉浸聊天，风月AI聊天软件的每一步操作都为你精心打磨。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
        {fyaiScreenshots.map((shot) => (
          <figure key={shot.title} className="flex flex-col items-center">
            <div className="w-full max-w-[260px] rounded-[2rem] border border-background-200 bg-background-100 p-3 transition-colors hover:border-primary-300">
              <div className="overflow-hidden rounded-[1.5rem] border border-background-200 bg-foreground-950">
                <img
                  src={shot.image}
                  alt={`风月AI软件截图 - ${shot.title}`}
                  title={`风月AI聊天软件${shot.title}`}
                  className="block aspect-[9/16] w-full object-contain"
                />
              </div>
            </div>
            <figcaption className="mt-5 text-center">
              <h3 className="font-heading text-base font-bold text-foreground-950">{shot.title}</h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{shot.desc}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}